export const classes = {
  wrapper:
    'w-full cursor-pointer hover:bg-black/5 dark:hover:bg-white/5 flex justify-between py-3 pl-4 pr-2 rounded-xl mb-2',
  contentWrapper: 'grow',
  description: 'text-sm font-medium text-taupe-3 dark:text-mauve-1',
  timestamp: 'text-xs text-taupe-2 mt-1 dark:text-mauve-2',
  optionsWrapper: 'place-center pl-2 w-10',
  status: 'read-status size-2 rounded-full bg-[#3b6fe0]',
  closeIcon:
    'close-icon size-4 text-taupe-1 hover:text-taupe-2 dark:text-mauve-3 p-0 m-0',
};

export const styles = {
  wrapper: {
    '&:hover .read-status': {
      display: 'none',
    },
    '&:hover .close-icon': {
      display: 'inline-block',
    },
    '& .close-icon': {
      display: 'none',
    },
  },
};
